import eligibilityRules from './eligibilityRules'

function checkEligibility({ age, gender, heightFt, heightIn, weight }) {
  if (age < 15 || !heightFt || !heightIn || !weight) {
    return true
  }

  return (
    Boolean(eligibilityRules[`${heightFt}_${heightIn}`]) &&
    eligibilityRules[`${heightFt}_${heightIn}`][gender][0] < weight &&
    eligibilityRules[`${heightFt}_${heightIn}`][gender][1] > weight
  )
}

export default checkEligibility
